module.exports = "fonts/GilroyMedium.woff";